<template>
  <div class="page-listings">
  
    <pricelist-tour v-if="$store.state.tour & !loading" />
    
    <section
      v-if="loading || !parts"
      data-v-5a90ec03
      class="pt-5 pb-2 pixelsbghex bs-shadow mobile-top"
      style="min-height: 198px"
    >
      <div data-v-5a90ec03 class="container">
        <h1 v-if="this.listType == 'COMMERCIAL'" class="text-white mb0 lh1">
          Loading Commercial Price List....
        </h1>
        <h1 v-else class="text-white mb0 lh1">
          Loading Service Price List....
        </h1>
        <br />
        <div class="hollow-dots-spinner">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </section>
    <section v-else class="pt-5 pb-2 pixelsbghex bs-shadow mobile-top">
      <div data-v-5a90ec03 class="container">

<!--
        <input
          id="pricelist-step-1"
          class="top-search mt0"
          type="text"
          placeholder="Search by Catalog group, Catalog Number, or Description"
          v-model="search"
          style="padding: 15px;"
        />
-->
        <div class="input-wrap">
        <input
          id="pricelist-step-1"
          class="top-search mt0"
          type="text"
          placeholder="Search by Catalog group, Catalog Number, or Description"
          style="padding: 15px;"
          v-model="search"
          @keyup.enter.prevent="searchQuery"
        />

        <button
            :class="[showButton ? 'clear-btn' : 'clear-hide']"
            @click="clearSearch"
            type="button"
            class="d-flex align-items-center pr-3 clear-btn"
          >
            <svg
              class="w-4 h-4 text-[#429da8] hover:text-[#1E3040]"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path
                d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
              ></path>
            </svg>
          </button>
        </div>


        <div class="search-btns">
          <div id="pricelist-step-2" class="radios">
            <div class="control-group">
              <label class="control control--radio">
                Service
                <input
                  @click="serviceSyncer"
                  type="radio"
                  name="radio"
                  v-model="listType"
                  value="SERVICE"
                />
                <div class="control__indicator"></div>
              </label>
              <label class="control control--radio">
                Commercial
                <input
                  @click="commercialSyncer"
                  type="radio"
                  name="radio"
                  v-model="listType"
                  value="COMMERCIAL"
                />
                <div class="control__indicator"></div>
              </label>
            </div>
          </div>

          <div class="left-side">
            <!--
            <div class="ac-select">
              <select
                class="form-control"
                id="exampleFormControlSelect1"
                v-model="acFilter"
              >
                <option :value="null" selected class="all-contractors">
                  Area Contractor
                </option>
                <option v-for="ac in acs" :key="ac.acid" :value="ac.acid">
                  {{ " " + toUpperCase(ac.acName) }}
                </option>
           
              </select>
            </div>
            -->
            <!--
            <div class="dates" id="dates">
              <datepicker
                format="MMM dd yyyy"
                placeholder="From Date"
                v-model="startDate"
                wrapperClass="pickthedate"
              ></datepicker>
              <datepicker
                format="MMM dd yyyy"
                placeholder="To Date"
                v-model="endDate"
                wrapperClass="pickthedate"
              ></datepicker>
            </div>
            -->
          </div>
          <div class="right-side">
            <button
              v-if="search.length && searchStarted == false"
              @click.prevent="searchParts"
              class="search"
            >
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>

            <button v-else class="search" disabled>
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
          </div>
        </div>

        <!--
        <div class="date-area">
          <vc-calendar mode="range" v-model="attributes" :max-date="new Date()" is-inline />
        </div>
        -->
      </div>
    </section>
    <!--

		<section v-else class="py-5 bg9 bs-shadow mobile-top">
			<div class="container">
				<input
					class="top-search bs-large mt0"
					type="text"
					placeholder="Search parts by order number, invoice number, or job name"
					v-model="search"
					@click="searchReset()"
				/>
			</div>
		</section>
    -->
    <div class="container">
      <div class="row">
        <div
          v-if="loading == true"
          class="col-xs-12 col-sm-12 col-12 col-lg-12"
        >
          <div class="flex-box-wrap pt150 pb150">
            <div class="flex-internal">
              <atom-spinner
                :animation-duration="1000"
                :size="40"
                :color="'#575757'"
              />
              <p>Loading......</p>
            </div>
          </div>
        </div>

        <div
          v-else-if="
            loading == false && !filteredparts.length && searchStarted == true
          "
          class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter"
        >
          <div class="sorry-box">
            <img src="@/assets/img/sad.svg" />
            <h3>Sorry, no parts were found...</h3>
            <button class="btn-primary" @click="firstLoad">
              Show me some parts
            </button>
          </div>
        </div>

        <div v-else class="col-xs-12 col-sm-12 col-12 col-lg-12">
          <div
            class="
              gsa-header
              d-flex
              align-items-center
              p-3
              mt-3
              mb10
              rounded
              box-shadow
            "
          >
            <p class="mrauto mbo">
              Page {{ currPage }} of
              {{ Math.ceil(this.filteredparts.length / 100) }}
            </p>
            <div class="pag-wrapper mlauto">
              <div id="pricelist-step-3" class="nav-btns">
                <button v-if="this.currPage === 1" disabled>
                  <i class="material-icons">keyboard_arrow_left</i> Back
                </button>

                <button v-else @click.prevent="setPage(currPage - 1)">
                  <i class="material-icons">keyboard_arrow_left</i> Back
                </button>

                <button
                  v-if="
                    this.currPage === this.totalPage ||
                    this.currPage == Math.ceil(this.filteredparts.length / 100)
                  "
                  disabled
                >
                  Next
                  <i class="material-icons">keyboard_arrow_right</i>
                </button>

                <button v-else @click.prevent="setPage(currPage + 1)">
                  Next
                  <i class="material-icons">keyboard_arrow_right</i>
                </button>
              </div>

              <!--
          <p class="mtauto" v-if="search.length">Results are being filtered</p>
          <p class="mtauto" v-else>Page {{currPage}} of {{ totalPage }} </p>
          <div class="nav-btns">

              <button v-if="this.currPage === 1" disabled><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-else @click.prevent="setPage(currPage-1)"><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-if="this.currPage === this.totalPage" disabled>Next <i class="material-icons">keyboard_arrow_right</i></button>

              <button v-else @click.prevent="setPage(currPage+1)">Next <i class="material-icons">keyboard_arrow_right</i></button>

          </div>
              -->
            </div>
          </div>

          <div>
            <div class="listing">
              <div class="d-flex">
                <div class="mr-auto">
  <h2 class="mb0">{{ listType === "COMMERCIAL" ? "Commercial" : "Service" }} Price List</h2>
  <span class="list-count">{{ filteredparts.length.toLocaleString() }} parts</span>
</div>

                <div class="mlauto">
                  <download-csv
                    id="pricelist-step-4"
                    class="mb0 lh1 list-btn dib d-flex center"
                    :data="parts"
                    :name="'name' + '.csv'"
                    >Download CSV</download-csv
                  >
                </div>
              </div>

              <!--
          <div v-for="gsa in parts" :key="gsa.Tid">
              -->
              <div class="gsa table-responsive">
               <table class="table-striped table-bordered" style="display: table; min-width: 100%">
  <thead>
    <tr>
      <th
        v-for="c in priceColumns"
        :key="c.key"
        scope="col"
        class="table-link"
        :class="[c.cls, { 'column-active': columnSort === c.key }]"
        @click="sortCol(c.key)"
      >
        <span class="th-inner">
          <span>{{ c.label }}</span>
          <i class="material-icons carrot-icon" :class="{ 'carrot-icon-active': columnSort === c.key }">filter_list</i>
        </span>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      v-for="(part, index) in filteredparts.slice(pageStart, pageStart + countOfPage)"
      :key="part.catalog_No + '-' + index"
    >
      <td class="type">{{ part.price_List_No }}</td>
      <td class="group">{{ part.catalog_Group }}</td>
      <td class="catno">{{ part.catalog_No }}</td>
      <td class="desc">{{ part.description }}</td>
      <td class="num price">{{ formatPrice(part.list_Price) }}</td>
      <td class="num weight">
        <template v-if="part.weight_Gross != null && part.weight_Gross !== ''">
          {{ part.weight_Gross }}<span class="unit">lbs</span>
        </template>
        <span v-else class="muted">—</span>
      </td>
    </tr>
  </tbody>
</table>
              </div>
              <!-- card -->
            </div>
          </div>

          <div
            class="
              gsa-header
              d-flex
              align-items-center
              p-3
              mb-3
              mt10
              rounded
              box-shadow
            "
          >
            <p class="mrauto mbo">
              Page {{ currPage }} of
              {{ Math.ceil(this.filteredparts.length / 100) }}
            </p>
            <div class="pag-wrapper mlauto">
              <div class="nav-btns">
                <button v-if="this.currPage === 1" disabled>
                  <i class="material-icons">keyboard_arrow_left</i> Back
                </button>

                <button v-else @click.prevent="setPage(currPage - 1)">
                  <i class="material-icons">keyboard_arrow_left</i> Back
                </button>

                <button
                  v-if="
                    this.currPage === this.totalPage ||
                    this.currPage == Math.ceil(this.filteredparts.length / 100)
                  "
                  disabled
                >
                  Next
                  <i class="material-icons">keyboard_arrow_right</i>
                </button>

                <button v-else @click.prevent="setPage(currPage + 1)">
                  Next
                  <i class="material-icons">keyboard_arrow_right</i>
                </button>
              </div>

              <!--
          <p class="mtauto" v-if="search.length">Results are being filtered</p>
          <p class="mtauto" v-else>Page {{currPage}} of {{ totalPage }} </p>
          <div class="nav-btns">

              <button v-if="this.currPage === 1" disabled><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-else @click.prevent="setPage(currPage-1)"><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-if="this.currPage === this.totalPage" disabled>Next <i class="material-icons">keyboard_arrow_right</i></button>

              <button v-else @click.prevent="setPage(currPage+1)">Next <i class="material-icons">keyboard_arrow_right</i></button>

          </div>
              -->
            </div>
          </div>
        </div>
        <!-- end other column -->
      </div>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import JsonCSV from "vue-json-csv";
import { formatCurrency } from '../utils/utils';
import pricelistTour from "../components/Tours/pricelistTour.vue";

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    //Authorization: "Bearer " + wontworkqwd2iwedjqoewiudwo
  },
};

export default {
  name: "Parts",
  components: {
    AtomSpinner,
    JsonCSV,
    pricelistTour,
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      backend: import.meta.env.VITE_APP_SERVER_URL,
      searchValue: "",
      search: "",
      storedListings: [],
      searchRender: false,
      startDate: null,
      endDate: null,
      searchStarted: false,
      acs: [],
      parts: [],
      selectedCat: "Show All",
      acFilter: null,
      searching: false,
      loading: true,
      countOfPage: 100,
      currPage: 1,
      noGSAFound: false,
      forumCats: [
        { id: 0, name: "Show All" },
        { id: 1, name: "Configura" },
        { id: 2, name: "Marketing" },
        { id: 3, name: "Other" },
        { id: 4, name: "Process" },
        { id: 5, name: "Product" },
        { id: 6, name: "Spacenet" },
      ],
      PDFload: false,
      PDFfile: null,
      PDFError: false,
      formattedData: [],
      listType: "SERVICE",
      colSort: false,
      columnSort: "",
      priceColumns: [
        { key: "price_List_No", label: "Type",        cls: "ten" },
        { key: "catalog_Group", label: "Cat Group",   cls: "ten" },
        { key: "catalog_No",    label: "Cat No",      cls: "ten" },
        { key: "description",   label: "Description", cls: "forty" },
        { key: "list_Price",    label: "List Price",  cls: "ten num" },
        { key: "weight_Gross",  label: "Weight",      cls: "ten num" },
      ],
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.searchValue = "";
      this.startDate = null;
      this.acFilter = null;
      this.endDate = null;
      this.searchStarted = false;
      this.$store.commit("setActivePage", "order-manage");

      return axios
        .get(`${this.ordermanageapi}/pricelist?type=${this.listType}`, auth)
        .then((response) => {
          //console.log(response);
          this.parts = response.data.prices;
          this.loading = false;
          this.$store.commit("UPDATE_COMMERCIAL", this.parts);
          //const unique = [...new Set(this.parts.map(item => item.catalog_Group + item.catalog_Group_Desc))];

          /*const unique = [...new Set(this.parts.map(item => item.catalog_Group ))];
            console.log("cats " + unique);

            let newList = [];
            for (let i = 0; i < unique.length; i++) {

                this.parts.filter(function (e) {
                    if(e.catalog_Group == unique[i]){
                        newList.push(e);
                    }                 
                });

            }
            console.log("new list " + newList.length);
            console.log("original list " + this.parts.length);
            this.formattedData = newList;
            */
        });
    },
    formatPrice(amount) {
      return formatCurrency(amount);
    },

    searchQuery() {
      this.searchStarted = true;
    },


    clearSearch: function () {
      this.searchStarted = false;
      this.search = "";
    },
    searchParts: function () {
      this.searchStarted = true;
    },

    setPage: function (idx) {
      //this.search = "";
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      this.currPage = idx;
    },

    catSwitcher: function (catType) {
      //console.log(catType);
      let category = catType;
      //console.log(category);
      if (category !== "Show All") {
        this.selectedCat = category;
        this.search = "";
        //console.log(category);
      } else {
        this.selectedCat = "Show All";
      }
    },

    toUpperCase: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.toUpperCase();
      });
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    commercialSyncer: function () {
      //console.log('Commercial');
      this.listType = "COMMERCIAL";
      this.loading = true;
      return axios
        .get(`${this.ordermanageapi}/pricelist?type=COMMERCIAL`, auth)
        .then((response) => {
          //console.log(response);
          this.parts = response.data.prices;
          this.loading = false;
        });
    },
    serviceSyncer: function () {
      //console.log('Service');
      this.listType = "SERVICE";
      this.loading = true;
      return axios
        .get(`${this.ordermanageapi}/pricelist?type=SERVICE`, auth)
        .then((response) => {
          //console.log(response);
          this.parts = response.data.prices;
          this.loading = false;
        });
    },
    sortCol(type) {
  this.columnSort = type;
  const dir = this.colSort ? 1 : -1;
  const numeric = type === "list_Price" || type === "weight_Gross";
  const val = r => numeric ? (Number(r[type]) || 0) : String(r[type] ?? "").toLowerCase();
  this.filteredparts.sort((a, b) => (val(a) > val(b) ? 1 : val(a) < val(b) ? -1 : 0) * dir);
  this.colSort = !this.colSort;
},
    clearSearch() {
      this.searchStarted = false;
      this.search = "";
    },
  },
  computed: {
    showButton() {
      if (this.search.trim().length > 0) {
        // console.log('true')
        return true;
      } else {
        // console.log('false')
        return false;
      }
    },
    activeNav() {
      return this.$store.state.activePage;
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    filteredparts: function () {
      //set the current page to 0
      this.currPage = 1;
      //if the search box is filled in
      if (this.search.trim() !== "" && this.searchStarted == true) {
        return this.parts.filter((e) => {
          //filter the subject line by what is filled in the search box
          return (
            e.description.toLowerCase().indexOf(this.search.toLowerCase()) >
              -1 ||
            e.catalog_No.toLowerCase().indexOf(this.search.toLowerCase()) >
              -1 ||
            e.catalog_Group.toLowerCase().indexOf(this.search.toLowerCase()) >
              -1
          );
        });
      } else {
        return this.parts;
      }
    },

    foundNoGSA: function () {
      if (this.search.length > 1 && this.filteredparts.length === 0) {
        //this.noUserFound = true;
        return true;
      }
    },

    pageStart: function () {
      return (this.currPage - 1) * this.countOfPage;
    },

    totalPage: function () {
      return Math.ceil(this.parts.length / this.countOfPage);
    },

    listingRestore: function () {
      if (
        !this.searchValue &&
        !this.loading &&
        !this.searching &&
        this.storedListings.length >= this.listings
      ) {
        //console.log("fired off");
        this.listings = this.storedListings;
      }
      return;
    },
    searchEndpointCompute: function () {
      //has order number, no start, no end, no ac
      if (
        this.searchValue.length &&
        !this.startDate &&
        !this.endDate &&
        !this.acFilter
      ) {
        return `${this.ordermanageapi}/pricelist?search=${this.searchValue}`;
      } else if (
        //has order number, and start, no end, no ac
        this.searchValue.length &&
        this.startDate != null &&
        this.endDate === null &&
        this.acFilter === null
      ) {
        return `${this.ordermanageapi}/pricelist?search=${
          this.searchValue
        }&start=${this.formatDate(this.startDate)}`;
      } else if (
        //has order number, and end, no start, no ac
        this.searchValue.length &&
        this.startDate === null &&
        this.acFilter === null &&
        this.endDate != null
      ) {
        return `${this.ordermanageapi}/pricelist?search=${
          this.searchValue
        }&end=${this.formatDate(this.endDate)}`;
      } else if (
        // has three, no ac
        this.searchValue.length &&
        this.startDate != null &&
        this.acFilter === null &&
        this.endDate != null
      ) {
        return `${this.ordermanageapi}/pricelist?search=${
          this.searchValue
        }&start=${this.formatDate(this.startDate)}&end=${this.formatDate(
          this.endDate
        )}`;
      } else if (
        //only has end
        !this.searchValue &&
        this.startDate === null &&
        this.endDate != null
      ) {
        return `${this.ordermanageapi}/pricelist?end=${this.formatDate(
          this.endDate
        )}`;
      } else if (
        //only has start
        !this.searchValue &&
        this.startDate != null &&
        this.endDate === null
      ) {
        return `${this.ordermanageapi}/pricelist?start=${this.formatDate(
          this.startDate
        )}`;
      } else if (
        //has start and end
        !this.searchValue &&
        this.startDate != null &&
        this.endDate != null
      ) {
        return `${this.ordermanageapi}/pricelist?start=${this.formatDate(
          this.startDate
        )}&end=${this.formatDate(this.endDate)}`;
      } else if (
        //has all 4
        this.searchValue.length &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        return `${this.ordermanageapi}/pricelist?ac=${this.acFilter}`;
      } else if (
        //has only ac
        !this.searchValue &&
        this.startDate === null &&
        this.endDate === null &&
        this.acFilter != null
      ) {
        return `${this.ordermanageapi}/pricelist?ac=${this.acFilter}`;
      } else if (
        //has ac and start
        !this.searchValue &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate === null
      ) {
        return `${this.ordermanageapi}/pricelist?start=${this.formatDate(
          this.startDate
        )}&ac=${this.acFilter}`;
      } else if (
        //has ac and end
        !this.searchValue &&
        this.startDate === null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        return `${this.ordermanageapi}/pricelist?end=${this.formatDate(
          this.endDate
        )}&ac=${this.acFilter}`;
      } else if (
        //has ac and number
        this.searchValue.length &&
        this.startDate === null &&
        this.acFilter != null &&
        this.endDate === null
      ) {
        return `${this.ordermanageapi}/pricelist?search=${this.searchValue}&ac=${this.acFilter}`;
      } else if (
        //has ac and start and end
        !searchValue.length &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        return `${this.ordermanageapi}/pricelist?ac=${
          this.acFilter
        }&start=${this.formatDate(this.startDate)}&end=${this.formatDate(
          this.endDate
        )}`;
      } else {
        return `${this.ordermanageapi}/pricelist`;
      }
    },
  },
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
  },

  mounted() {
    this.firstLoad();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}

.listing {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.gsa-bottom {
  align-items: flex-end;
}
.gsa-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.small-lh {
  line-height: 1.4em;
}

.listing {
  overflow: scroll;
}

.table-responsive {
  display: table;
  margin: 0;
  padding: 0;
  min-width: 100%;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
  line-height: 1;
}
.search-btns {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
  padding: 23px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.search-btns .clear {
  margin-right: 0;
  margin-left: auto;
  padding: 23px 15px;
}
.search-btns .search {
  /*margin-left: auto;*/
  margin-right: 0;
  margin-left: auto;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}

@media all and (min-width: 768px) {
  .dates {
    display: flex;
    color: #757575 !important;
  }
}
.top-search {
  color: #757575;
}
select.form-control:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575;
}
.all-contractors {
  color: #757575 !important;
}
.pdfButton {
  cursor: pointer;
}
.radios {
  color: #fff;
}

/* radios */
.control-group {
  margin-top: 5px;
  display: inline-block;
  vertical-align: top;
  text-align: left;
}
.control {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 5px;
  cursor: pointer;
  font-size: 18px;
  margin-right: 10px;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
}
.control--radio .control__indicator {
  border-radius: 50%;
}
.control:hover input ~ .control__indicator,
.control input:focus ~ .control__indicator {
  background: #ccc;
}
.control input:checked ~ .control__indicator {
  background: #252627;
}
.control:hover input:not([disabled]):checked ~ .control__indicator,
.control input:checked:focus ~ .control__indicator {
  background: #252627;
}
.control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.control__indicator:after {
  content: "";
  position: absolute;
  display: none;
}
.control input:checked ~ .control__indicator:after {
  display: block;
}
.control--checkbox .control__indicator:after {
  left: 8px;
  top: 4px;
  width: 3px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}
.control--radio .control__indicator:after {
  left: 7px;
  top: 7px;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background: #fff;
}
.control--radio input:disabled ~ .control__indicator:after {
  background: #7b7b7b;
}
.right-side {
  text-align: right;
  flex: 1;
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 14px;
  border: none;
  background: none;
}
.clear-hide {
  display: none !important;
}
.input-wrap {
  position: relative;
  display: block;
}
.search-btns {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
  padding: 23px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.search-btns .clear {
  margin-right: 0;
  margin-left: auto;
  padding: 23px 15px;
}
.search-btns .search {
  /*margin-left: auto;*/
  margin-right: 0;
  margin-left: auto;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}

/* ---------- Table typography ---------- */
.listing table { font-size: 14px; color: #2f3640; font-variant-numeric: tabular-nums; }

.table-striped th {
  background: #4d5967;
  color: #fff;
  font-size: 12px;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1.2;
  padding: 10px;
  white-space: nowrap;
  vertical-align: middle;
}
.th-inner { display: flex; align-items: center; justify-content: space-between; gap: 6px; }
.table-striped th.num .th-inner { justify-content: flex-end; }

.table-striped td {
  padding: 10px;
  line-height: 1.35;
  font-weight: 400 !important;
  vertical-align: middle;
}

/* Column roles */
.table-striped td.type { color: #8a9099; font-size: 13px; white-space: nowrap; }
.table-striped td.group { color: #4d5967; white-space: nowrap; }
.table-striped td.catno { color: #1f2933; font-weight: 500 !important; white-space: nowrap; }
.table-striped td.desc { color: #2f3640; }
.table-striped td.num { text-align: right; white-space: nowrap; }
.table-striped td.price { color: #1f2933; font-weight: 400 !important; }
.table-striped td.weight { color: #4d5967; }
.table-striped .unit { color: #8a9099; margin-left: 3px; font-size: 12px; }
.table-striped .muted { color: #a0a6ad; }

.list-count { color: #8a9099; font-size: 13px; }

/* Sort icons */
.carrot-icon { font-size: 16px; opacity: 0.45; vertical-align: middle; }
.carrot-icon-active { opacity: 1; }

.pixelsbghex {
  background-color: #475059;
  background-size: cover;
  background-position: center;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200' preserveAspectRatio='xMidYMid slice'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%2356626d'/%3E%3Cstop offset='1' stop-color='%2356626d' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%2337778a'/%3E%3Cstop offset='1' stop-color='%2337778a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%232b5c60'/%3E%3Cstop offset='1' stop-color='%232b5c60' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23667787'/%3E%3Cstop offset='1' stop-color='%23667787' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3ClinearGradient id='base' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='.5' stop-color='%2356626d'/%3E%3Cstop offset='1' stop-color='%231a8182'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill='%23475059' width='1950' height='1200'/%3E%3Cpolygon fill='%23454e56' stroke='%23414a52' stroke-width='3' points='0,-180 0,-90 -77.9,-45 -155.9,-90 -155.9,-180 -77.9,-225'/%3E%3Cpolygon fill='%2345525b' stroke='%23404b53' stroke-width='3' points='155.9,-180 155.9,-90 77.9,-45 0,-90 0,-180 77.9,-225'/%3E%3Cpolygon fill='%23475b63' stroke='%233c4f56' stroke-width='3' points='311.8,-180 311.8,-90 233.8,-45 155.9,-90 155.9,-180 233.8,-225'/%3E%3Cpolygon fill='%233d5860' stroke='%23395359' stroke-width='3' points='467.7,-180 467.7,-90 389.7,-45 311.8,-90 311.8,-180 389.7,-225'/%3E%3Cpolygon fill='%233d6067' stroke='%2336565c' stroke-width='3' points='623.5,-180 623.5,-90 545.6,-45 467.7,-90 467.7,-180 545.6,-225'/%3E%3Cpolygon fill='%23355f65' stroke='%23325a5f' stroke-width='3' points='779.4,-180 779.4,-90 701.5,-45 623.5,-90 623.5,-180 701.5,-225'/%3E%3Cpolygon fill='%2333666b' stroke='%232f5d62' stroke-width='3' points='935.3,-180 935.3,-90 857.4,-45 779.4,-90 779.4,-180 857.4,-225'/%3E%3Cpolygon fill='%23366e73' stroke='%232c6165' stroke-width='3' points='1091.2,-180 1091.2,-90 1013.2,-45 935.3,-90 935.3,-180 1013.2,-225'/%3E%3Cpolygon fill='%232b6c70' stroke='%23286568' stroke-width='3' points='1247.1,-180 1247.1,-90 1169.1,-45 1091.2,-90 1091.2,-180 1169.1,-225'/%3E%3Cpolygon fill='%232c7377' stroke='%2325686c' stroke-width='3' points='1403,-180 1403,-90 1325,-45 1247.1,-90 1247.1,-180 1325,-225'/%3E%3Cpolygon fill='%23247275' stroke='%23226c6f' stroke-width='3' points='1558.8,-180 1558.8,-90 1480.9,-45 1403,-90 1403,-180 1480.9,-225'/%3E%3Cpolygon fill='%2321797b' stroke='%231f6f72' stroke-width='3' points='1714.7,-180 1714.7,-90 1636.8,-45 1558.8,-90 1558.8,-180 1636.8,-225'/%3E%3Cpolygon fill='%23248183' stroke='%231b7375' stroke-width='3' points='1870.6,-180 1870.6,-90 1792.7,-45 1714.7,-90 1714.7,-180 1792.7,-225'/%3E%3Cpolygon fill='%231a7f80' stroke='%23187778' stroke-width='3' points='2026.5,-180 2026.5,-90 1948.6,-45 1870.6,-90 1870.6,-180 1948.6,-225'/%3E%3Cpolygon fill='%231d8384' stroke='%23187778' stroke-width='3' points='2182.4,-180 2182.4,-90 2104.4,-45 2026.5,-90 2026.5,-180 2104.4,-225'/%3E%3Cpolygon fill='%234a535b' stroke='%23414a52' stroke-width='3' points='-77.9,-45 -77.9,45 -155.9,90 -233.8,45 -233.8,-45 -155.9,-90'/%3E%3Cpolygon fill='%23454e56' stroke='%23414a52' stroke-width='3' points='77.9,-45 77.9,45 0,90 -77.9,45 -77.9,-45 -0,-90'/%3E%3Cpolygon fill='%2343545c' stroke='%233e4d55' stroke-width='3' points='233.8,-45 233.8,45 155.9,90 77.9,45 77.9,-45 155.9,-90'/%3E%3Cpolygon fill='%23465d64' stroke='%233b5158' stroke-width='3' points='389.7,-45 389.7,45 311.8,90 233.8,45 233.8,-45 311.8,-90'/%3E%3Cpolygon fill='%233b5a61' stroke='%2337545b' stroke-width='3' points='545.6,-45 545.6,45 467.7,90 389.7,45 389.7,-45 467.7,-90'/%3E%3Cpolygon fill='%233c6268' stroke='%2334585e' stroke-width='3' points='701.5,-45 701.5,45 623.5,90 545.6,45 545.6,-45 623.5,-90'/%3E%3Cpolygon fill='%23336166' stroke='%23315c61' stroke-width='3' points='857.4,-45 857.4,45 779.4,90 701.5,45 701.5,-45 779.4,-90'/%3E%3Cpolygon fill='%2331686d' stroke='%232d5f64' stroke-width='3' points='1013.2,-45 1013.2,45 935.3,90 857.4,45 857.4,-45 935.3,-90'/%3E%3Cpolygon fill='%23347074' stroke='%232a6367' stroke-width='3' points='1169.1,-45 1169.1,45 1091.2,90 1013.2,45 1013.2,-45 1091.2,-90'/%3E%3Cpolygon fill='%232a6e71' stroke='%2327666a' stroke-width='3' points='1325,-45 1325,45 1247.1,90 1169.1,45 1169.1,-45 1247.1,-90'/%3E%3Cpolygon fill='%232a7579' stroke='%23246a6d' stroke-width='3' points='1480.9,-45 1480.9,45 1403,90 1325,45 1325,-45 1403,-90'/%3E%3Cpolygon fill='%23227476' stroke='%23206e70' stroke-width='3' points='1636.8,-45 1636.8,45 1558.8,90 1480.9,45 1480.9,-45 1558.8,-90'/%3E%3Cpolygon fill='%231f7b7d' stroke='%231d7173' stroke-width='3' points='1792.7,-45 1792.7,45 1714.7,90 1636.8,45 1636.8,-45 1714.7,-90'/%3E%3Cpolygon fill='%23238384' stroke='%231a7576' stroke-width='3' points='1948.6,-45 1948.6,45 1870.6,90 1792.7,45 1792.7,-45 1870.6,-90'/%3E%3Cpolygon fill='%231a7f80' stroke='%23187778' stroke-width='3' points='2104.4,-45 2104.4,45 2026.5,90 1948.6,45 1948.6,-45 2026.5,-90'/%3E%3Cpolygon fill='%2348515a' stroke='%23434b54' stroke-width='3' points='0,90 0,180 -77.9,225 -155.9,180 -155.9,90 -77.9,45'/%3E%3Cpolygon fill='%234a565f' stroke='%23414d55' stroke-width='3' points='155.9,90 155.9,180 77.9,225 0,180 0,90 77.9,45'/%3E%3Cpolygon fill='%2341555d' stroke='%233e5158' stroke-width='3' points='311.8,90 311.8,180 233.8,225 155.9,180 155.9,90 233.8,45'/%3E%3Cpolygon fill='%23405b63' stroke='%233b545b' stroke-width='3' points='467.7,90 467.7,180 389.7,225 311.8,180 311.8,90 389.7,45'/%3E%3Cpolygon fill='%2342646b' stroke='%2338575e' stroke-width='3' points='623.5,90 623.5,180 545.6,225 467.7,180 467.7,90 545.6,45'/%3E%3Cpolygon fill='%23386168' stroke='%23355b61' stroke-width='3' points='779.4,90 779.4,180 701.5,225 623.5,180 623.5,90 701.5,45'/%3E%3Cpolygon fill='%2339696f' stroke='%23315e64' stroke-width='3' points='935.3,90 935.3,180 857.4,225 779.4,180 779.4,90 857.4,45'/%3E%3Cpolygon fill='%2331676d' stroke='%232e6167' stroke-width='3' points='1091.2,90 1091.2,180 1013.2,225 935.3,180 935.3,90 1013.2,45'/%3E%3Cpolygon fill='%232f6e73' stroke='%232b656a' stroke-width='3' points='1247.1,90 1247.1,180 1169.1,225 1091.2,180 1091.2,90 1169.1,45'/%3E%3Cpolygon fill='%2332757a' stroke='%2328686d' stroke-width='3' points='1403,90 1403,180 1325,225 1247.1,180 1247.1,90 1325,45'/%3E%3Cpolygon fill='%23277378' stroke='%23256b70' stroke-width='3' points='1558.8,90 1558.8,180 1480.9,225 1403,180 1403,90 1480.9,45'/%3E%3Cpolygon fill='%23287b7e' stroke='%23216f73' stroke-width='3' points='1714.7,90 1714.7,180 1636.8,225 1558.8,180 1558.8,90 1636.8,45'/%3E%3Cpolygon fill='%2320787c' stroke='%231e7275' stroke-width='3' points='1870.6,90 1870.6,180 1792.7,225 1714.7,180 1714.7,90 1792.7,45'/%3E%3Cpolygon fill='%231d8083' stroke='%231b7678' stroke-width='3' points='2026.5,90 2026.5,180 1948.6,225 1870.6,180 1870.6,90 1948.6,45'/%3E%3Cpolygon fill='%23248487' stroke='%231b7678' stroke-width='3' points='2182.4,90 2182.4,180 2104.4,225 2026.5,180 2026.5,90 2104.4,45'/%3E%3Cpolygon fill='%23505962' stroke='%23444d56' stroke-width='3' points='-77.9,225 -77.9,315 -155.9,360 -233.8,315 -233.8,225 -155.9,180'/%3E%3Cpolygon fill='%2349535c' stroke='%23444d56' stroke-width='3' points='77.9,225 77.9,315 0,360 -77.9,315 -77.9,225 -0,180'/%3E%3Cpolygon fill='%234a5a63' stroke='%23415159' stroke-width='3' points='233.8,225 233.8,315 155.9,360 77.9,315 77.9,225 155.9,180'/%3E%3Cpolygon fill='%23425861' stroke='%233e545c' stroke-width='3' points='389.7,225 389.7,315 311.8,360 233.8,315 233.8,225 311.8,180'/%3E%3Cpolygon fill='%23415e67' stroke='%233b575f' stroke-width='3' points='545.6,225 545.6,315 467.7,360 389.7,315 389.7,225 467.7,180'/%3E%3Cpolygon fill='%2343676e' stroke='%23385a62' stroke-width='3' points='701.5,225 701.5,315 623.5,360 545.6,315 545.6,225 623.5,180'/%3E%3Cpolygon fill='%2339646b' stroke='%23365d64' stroke-width='3' points='857.4,225 857.4,315 779.4,360 701.5,315 701.5,225 779.4,180'/%3E%3Cpolygon fill='%233a6b72' stroke='%23336067' stroke-width='3' points='1013.2,225 1013.2,315 935.3,360 857.4,315 857.4,225 935.3,180'/%3E%3Cpolygon fill='%23326970' stroke='%232f636a' stroke-width='3' points='1169.1,225 1169.1,315 1091.2,360 1013.2,315 1013.2,225 1091.2,180'/%3E%3Cpolygon fill='%23306f76' stroke='%232c676d' stroke-width='3' points='1325,225 1325,315 1247.1,360 1169.1,315 1169.1,225 1247.1,180'/%3E%3Cpolygon fill='%2333777d' stroke='%23296a6f' stroke-width='3' points='1480.9,225 1480.9,315 1403,360 1325,315 1325,225 1403,180'/%3E%3Cpolygon fill='%2329747a' stroke='%23266d72' stroke-width='3' points='1636.8,225 1636.8,315 1558.8,360 1480.9,315 1480.9,225 1558.8,180'/%3E%3Cpolygon fill='%23297c81' stroke='%23237075' stroke-width='3' points='1792.7,225 1792.7,315 1714.7,360 1636.8,315 1636.8,225 1714.7,180'/%3E%3Cpolygon fill='%2321797e' stroke='%23207378' stroke-width='3' points='1948.6,225 1948.6,315 1870.6,360 1792.7,315 1792.7,225 1870.6,180'/%3E%3Cpolygon fill='%23217f84' stroke='%231e7579' stroke-width='3' points='2104.4,225 2104.4,315 2026.5,360 1948.6,315 1948.6,225 2026.5,180'/%3E%3Cpolygon fill='%234c5660' stroke='%23464f58' stroke-width='3' points='0,360 0,450 -77.9,495 -155.9,450 -155.9,360 -77.9,315'/%3E%3Cpolygon fill='%23505d66' stroke='%2345515a' stroke-width='3' points='155.9,360 155.9,450 77.9,495 0,450 0,360 77.9,315'/%3E%3Cpolygon fill='%23465a63' stroke='%2342545d' stroke-width='3' points='311.8,360 311.8,450 233.8,495 155.9,450 155.9,360 233.8,315'/%3E%3Cpolygon fill='%2348616a' stroke='%233f575f' stroke-width='3' points='467.7,360 467.7,450 389.7,495 311.8,450 311.8,360 389.7,315'/%3E%3Cpolygon fill='%23405f68' stroke='%233d5a62' stroke-width='3' points='623.5,360 623.5,450 545.6,495 467.7,450 467.7,360 545.6,315'/%3E%3Cpolygon fill='%233f656e' stroke='%233a5d65' stroke-width='3' points='779.4,360 779.4,450 701.5,495 623.5,450 623.5,360 701.5,315'/%3E%3Cpolygon fill='%23436d75' stroke='%23386068' stroke-width='3' points='935.3,360 935.3,450 857.4,495 779.4,450 779.4,360 857.4,315'/%3E%3Cpolygon fill='%23396a72' stroke='%2335636b' stroke-width='3' points='1091.2,360 1091.2,450 1013.2,495 935.3,450 935.3,360 1013.2,315'/%3E%3Cpolygon fill='%23397079' stroke='%2332656d' stroke-width='3' points='1247.1,360 1247.1,450 1169.1,495 1091.2,450 1091.2,360 1169.1,315'/%3E%3Cpolygon fill='%23316e76' stroke='%232e6870' stroke-width='3' points='1403,360 1403,450 1325,495 1247.1,450 1247.1,360 1325,315'/%3E%3Cpolygon fill='%232f747c' stroke='%232b6b72' stroke-width='3' points='1558.8,360 1558.8,450 1480.9,495 1403,450 1403,360 1480.9,315'/%3E%3Cpolygon fill='%23317b83' stroke='%23276e75' stroke-width='3' points='1714.7,360 1714.7,450 1636.8,495 1558.8,450 1558.8,360 1636.8,315'/%3E%3Cpolygon fill='%23277980' stroke='%23247177' stroke-width='3' points='1870.6,360 1870.6,450 1792.7,495 1714.7,450 1714.7,360 1792.7,315'/%3E%3Cpolygon fill='%23278087' stroke='%2321747a' stroke-width='3' points='2026.5,360 2026.5,450 1948.6,495 1870.6,450 1870.6,360 1948.6,315'/%3E%3Cpolygon fill='%23237a81' stroke='%2321747a' stroke-width='3' points='2182.4,360 2182.4,450 2104.4,495 2026.5,450 2026.5,360 2104.4,315'/%3E%3Cpolygon fill='%234b565f' stroke='%2348515a' stroke-width='3' points='-77.9,495 -77.9,585 -155.9,630 -233.8,585 -233.8,495 -155.9,450'/%3E%3Cpolygon fill='%234e5862' stroke='%2348515a' stroke-width='3' points='77.9,495 77.9,585 0,630 -77.9,585 -77.9,495 -0,450'/%3E%3Cpolygon fill='%2351616a' stroke='%2345545e' stroke-width='3' points='233.8,495 233.8,585 155.9,630 77.9,585 77.9,495 155.9,450'/%3E%3Cpolygon fill='%23485e68' stroke='%23435861' stroke-width='3' points='389.7,495 389.7,585 311.8,630 233.8,585 233.8,495 311.8,450'/%3E%3Cpolygon fill='%234a656f' stroke='%23425b64' stroke-width='3' points='545.6,495 545.6,585 467.7,630 389.7,585 389.7,495 467.7,450'/%3E%3Cpolygon fill='%2344636d' stroke='%23405e68' stroke-width='3' points='701.5,495 701.5,585 623.5,630 545.6,585 545.6,495 623.5,450'/%3E%3Cpolygon fill='%23456974' stroke='%233f616b' stroke-width='3' points='857.4,495 857.4,585 779.4,630 701.5,585 701.5,495 779.4,450'/%3E%3Cpolygon fill='%2348707b' stroke='%233d636d' stroke-width='3' points='1013.2,495 1013.2,585 935.3,630 857.4,585 857.4,495 935.3,450'/%3E%3Cpolygon fill='%233f6d77' stroke='%233b656f' stroke-width='3' points='1169.1,495 1169.1,585 1091.2,630 1013.2,585 1013.2,495 1091.2,450'/%3E%3Cpolygon fill='%233e727d' stroke='%23376771' stroke-width='3' points='1325,495 1325,585 1247.1,630 1169.1,585 1169.1,495 1247.1,450'/%3E%3Cpolygon fill='%23356f79' stroke='%23326a73' stroke-width='3' points='1480.9,495 1480.9,585 1403,630 1325,585 1325,495 1403,450'/%3E%3Cpolygon fill='%2331757f' stroke='%232e6c75' stroke-width='3' points='1636.8,495 1636.8,585 1558.8,630 1480.9,585 1480.9,495 1558.8,450'/%3E%3Cpolygon fill='%23337c85' stroke='%23296e77' stroke-width='3' points='1792.7,495 1792.7,585 1714.7,630 1636.8,585 1636.8,495 1714.7,450'/%3E%3Cpolygon fill='%23297982' stroke='%2326717a' stroke-width='3' points='1948.6,495 1948.6,585 1870.6,630 1792.7,585 1792.7,495 1870.6,450'/%3E%3Cpolygon fill='%232a7e87' stroke='%2324737b' stroke-width='3' points='2104.4,495 2104.4,585 2026.5,630 1948.6,585 1948.6,495 2026.5,450'/%3E%3Cpolygon fill='%23525d67' stroke='%2349535d' stroke-width='3' points='0,630 0,720 -77.9,765 -155.9,720 -155.9,630 -77.9,585'/%3E%3Cpolygon fill='%234c5a64' stroke='%2348555f' stroke-width='3' points='155.9,630 155.9,720 77.9,765 0,720 0,630 77.9,585'/%3E%3Cpolygon fill='%234d606b' stroke='%23475862' stroke-width='3' points='311.8,630 311.8,720 233.8,765 155.9,720 155.9,630 233.8,585'/%3E%3Cpolygon fill='%23526974' stroke='%23465c66' stroke-width='3' points='467.7,630 467.7,720 389.7,765 311.8,720 311.8,630 389.7,585'/%3E%3Cpolygon fill='%234c6772' stroke='%2347606b' stroke-width='3' points='623.5,630 623.5,720 545.6,765 467.7,720 467.7,630 545.6,585'/%3E%3Cpolygon fill='%23516e7a' stroke='%2348636f' stroke-width='3' points='779.4,630 779.4,720 701.5,765 623.5,720 623.5,630 701.5,585'/%3E%3Cpolygon fill='%234d6b78' stroke='%23496671' stroke-width='3' points='935.3,630 935.3,720 857.4,765 779.4,720 779.4,630 857.4,585'/%3E%3Cpolygon fill='%234d707d' stroke='%23476773' stroke-width='3' points='1091.2,630 1091.2,720 1013.2,765 935.3,720 935.3,630 1013.2,585'/%3E%3Cpolygon fill='%234e7582' stroke='%23436874' stroke-width='3' points='1247.1,630 1247.1,720 1169.1,765 1091.2,720 1091.2,630 1169.1,585'/%3E%3Cpolygon fill='%2341717c' stroke='%233d6974' stroke-width='3' points='1403,630 1403,720 1325,765 1247.1,720 1247.1,630 1325,585'/%3E%3Cpolygon fill='%233e7682' stroke='%23366b75' stroke-width='3' points='1558.8,630 1558.8,720 1480.9,765 1403,720 1403,630 1480.9,585'/%3E%3Cpolygon fill='%2333737e' stroke='%23306d77' stroke-width='3' points='1714.7,630 1714.7,720 1636.8,765 1558.8,720 1558.8,630 1636.8,585'/%3E%3Cpolygon fill='%232f7984' stroke='%232c6f79' stroke-width='3' points='1870.6,630 1870.6,720 1792.7,765 1714.7,720 1714.7,630 1792.7,585'/%3E%3Cpolygon fill='%23317f8a' stroke='%2328717c' stroke-width='3' points='2026.5,630 2026.5,720 1948.6,765 1870.6,720 1870.6,630 1948.6,585'/%3E%3Cpolygon fill='%232a7a84' stroke='%2327717c' stroke-width='3' points='2182.4,630 2182.4,720 2104.4,765 2026.5,720 2026.5,630 2104.4,585'/%3E%3Cpolygon fill='%23505b65' stroke='%234b555f' stroke-width='3' points='-77.9,765 -77.9,855 -155.9,900 -233.8,855 -233.8,765 -155.9,720'/%3E%3Cpolygon fill='%2354606a' stroke='%234b565f' stroke-width='3' points='77.9,765 77.9,855 0,900 -77.9,855 -77.9,765 -0,720'/%3E%3Cpolygon fill='%234e5e69' stroke='%234a5963' stroke-width='3' points='233.8,765 233.8,855 155.9,900 77.9,855 77.9,765 155.9,720'/%3E%3Cpolygon fill='%23506571' stroke='%234a5d68' stroke-width='3' points='389.7,765 389.7,855 311.8,900 233.8,855 233.8,765 311.8,720'/%3E%3Cpolygon fill='%23586e7b' stroke='%234c616d' stroke-width='3' points='545.6,765 545.6,855 467.7,900 389.7,855 389.7,765 467.7,720'/%3E%3Cpolygon fill='%23556d7a' stroke='%234f6672' stroke-width='3' points='701.5,765 701.5,855 623.5,900 545.6,855 545.6,765 623.5,720'/%3E%3Cpolygon fill='%235c7482' stroke='%23526976' stroke-width='3' points='857.4,765 857.4,855 779.4,900 701.5,855 701.5,765 779.4,720'/%3E%3Cpolygon fill='%2358707e' stroke='%23536a78' stroke-width='3' points='1013.2,765 1013.2,855 935.3,900 857.4,855 857.4,765 935.3,720'/%3E%3Cpolygon fill='%23577382' stroke='%23506a78' stroke-width='3' points='1169.1,765 1169.1,855 1091.2,900 1013.2,855 1013.2,765 1091.2,720'/%3E%3Cpolygon fill='%23567785' stroke='%234a6a77' stroke-width='3' points='1325,765 1325,855 1247.1,900 1169.1,855 1169.1,765 1247.1,720'/%3E%3Cpolygon fill='%2346727f' stroke='%23416a77' stroke-width='3' points='1480.9,765 1480.9,855 1403,900 1325,855 1325,765 1403,720'/%3E%3Cpolygon fill='%23417784' stroke='%23396b78' stroke-width='3' points='1636.8,765 1636.8,855 1558.8,900 1480.9,855 1480.9,765 1558.8,720'/%3E%3Cpolygon fill='%23357380' stroke='%23326d79' stroke-width='3' points='1792.7,765 1792.7,855 1714.7,900 1636.8,855 1636.8,765 1714.7,720'/%3E%3Cpolygon fill='%23317986' stroke='%232d6f7b' stroke-width='3' points='1948.6,765 1948.6,855 1870.6,900 1792.7,855 1792.7,765 1870.6,720'/%3E%3Cpolygon fill='%23357e8b' stroke='%232b707d' stroke-width='3' points='2104.4,765 2104.4,855 2026.5,900 1948.6,855 1948.6,765 2026.5,720'/%3E%3Cpolygon fill='%2358646e' stroke='%234d5761' stroke-width='3' points='0,900 0,990 -77.9,1035 -155.9,990 -155.9,900 -77.9,855'/%3E%3Cpolygon fill='%2352606a' stroke='%234c5963' stroke-width='3' points='155.9,900 155.9,990 77.9,1035 0,990 0,900 77.9,855'/%3E%3Cpolygon fill='%23556773' stroke='%234c5d68' stroke-width='3' points='311.8,900 311.8,990 233.8,1035 155.9,990 155.9,900 233.8,855'/%3E%3Cpolygon fill='%23526673' stroke='%234d616d' stroke-width='3' points='467.7,900 467.7,990 389.7,1035 311.8,990 311.8,900 389.7,855'/%3E%3Cpolygon fill='%23586f7c' stroke='%23516673' stroke-width='3' points='623.5,900 623.5,990 545.6,1035 467.7,990 467.7,900 545.6,855'/%3E%3Cpolygon fill='%23627785' stroke='%23556977' stroke-width='3' points='779.4,900 779.4,990 701.5,1035 623.5,990 623.5,900 701.5,855'/%3E%3Cpolygon fill='%235f7382' stroke='%23596b7a' stroke-width='3' points='935.3,900 935.3,990 857.4,1035 779.4,990 779.4,900 857.4,855'/%3E%3Cpolygon fill='%23627787' stroke='%23586c7a' stroke-width='3' points='1091.2,900 1091.2,990 1013.2,1035 935.3,990 935.3,900 1013.2,855'/%3E%3Cpolygon fill='%23587180' stroke='%23536b79' stroke-width='3' points='1247.1,900 1247.1,990 1169.1,1035 1091.2,990 1091.2,900 1169.1,855'/%3E%3Cpolygon fill='%23517483' stroke='%234b6b78' stroke-width='3' points='1403,900 1403,990 1325,1035 1247.1,990 1247.1,900 1325,855'/%3E%3Cpolygon fill='%234d7886' stroke='%23416b78' stroke-width='3' points='1558.8,900 1558.8,990 1480.9,1035 1403,990 1403,900 1480.9,855'/%3E%3Cpolygon fill='%233d7382' stroke='%23396c79' stroke-width='3' points='1714.7,900 1714.7,990 1636.8,1035 1558.8,990 1558.8,900 1636.8,855'/%3E%3Cpolygon fill='%233a7988' stroke='%23336d7b' stroke-width='3' points='1870.6,900 1870.6,990 1792.7,1035 1714.7,990 1714.7,900 1792.7,855'/%3E%3Cpolygon fill='%23317584' stroke='%232e6f7d' stroke-width='3' points='2026.5,900 2026.5,990 1948.6,1035 1870.6,990 1870.6,900 1948.6,855'/%3E%3Cpolygon fill='%23317988' stroke='%232d6f7d' stroke-width='3' points='2182.4,900 2182.4,990 2104.4,1035 2026.5,990 2026.5,900 2104.4,855'/%3E%3Cpolygon fill='%2355616b' stroke='%234e5963' stroke-width='3' points='-77.9,1035 -77.9,1125 -155.9,1170 -233.8,1125 -233.8,1035 -155.9,990'/%3E%3Cpolygon fill='%235a6671' stroke='%234e5963' stroke-width='3' points='77.9,1035 77.9,1125 0,1170 -77.9,1125 -77.9,1035 -0,990'/%3E%3Cpolygon fill='%2353636e' stroke='%234d5c67' stroke-width='3' points='233.8,1035 233.8,1125 155.9,1170 77.9,1125 77.9,1035 155.9,990'/%3E%3Cpolygon fill='%23566a77' stroke='%234d606b' stroke-width='3' points='389.7,1035 389.7,1125 311.8,1170 233.8,1125 233.8,1035 311.8,990'/%3E%3Cpolygon fill='%23536976' stroke='%234f6370' stroke-width='3' points='545.6,1035 545.6,1125 467.7,1170 389.7,1125 389.7,1035 467.7,990'/%3E%3Cpolygon fill='%2359707f' stroke='%23526774' stroke-width='3' points='701.5,1035 701.5,1125 623.5,1170 545.6,1125 545.6,1035 623.5,990'/%3E%3Cpolygon fill='%23617786' stroke='%23556a78' stroke-width='3' points='857.4,1035 857.4,1125 779.4,1170 701.5,1125 701.5,1035 779.4,990'/%3E%3Cpolygon fill='%235c7282' stroke='%23566b79' stroke-width='3' points='1013.2,1035 1013.2,1125 935.3,1170 857.4,1125 857.4,1035 935.3,990'/%3E%3Cpolygon fill='%235d7685' stroke='%23546b79' stroke-width='3' points='1169.1,1035 1169.1,1125 1091.2,1170 1013.2,1125 1013.2,1035 1091.2,990'/%3E%3Cpolygon fill='%2352707f' stroke='%234e6a79' stroke-width='3' points='1325,1035 1325,1125 1247.1,1170 1169.1,1125 1169.1,1035 1247.1,990'/%3E%3Cpolygon fill='%234c7383' stroke='%23466a79' stroke-width='3' points='1480.9,1035 1480.9,1125 1403,1170 1325,1125 1325,1035 1403,990'/%3E%3Cpolygon fill='%23497888' stroke='%233e6b79' stroke-width='3' points='1636.8,1035 1636.8,1125 1558.8,1170 1480.9,1125 1480.9,1035 1558.8,990'/%3E%3Cpolygon fill='%233c7484' stroke='%23386c7b' stroke-width='3' points='1792.7,1035 1792.7,1125 1714.7,1170 1636.8,1125 1636.8,1035 1714.7,990'/%3E%3Cpolygon fill='%233a798a' stroke='%23336e7d' stroke-width='3' points='1948.6,1035 1948.6,1125 1870.6,1170 1792.7,1125 1792.7,1035 1870.6,990'/%3E%3Cpolygon fill='%23337485' stroke='%23316e7e' stroke-width='3' points='2104.4,1035 2104.4,1125 2026.5,1170 1948.6,1125 1948.6,1035 2026.5,990'/%3E%3Cpolygon fill='%23545f6a' stroke='%234f5a65' stroke-width='3' points='0,1170 0,1260 -77.9,1305 -155.9,1260 -155.9,1170 -77.9,1125'/%3E%3Cpolygon fill='%2355646f' stroke='%234f5c66' stroke-width='3' points='155.9,1170 155.9,1260 77.9,1305 0,1260 0,1170 77.9,1125'/%3E%3Cpolygon fill='%23596b77' stroke='%234d5e69' stroke-width='3' points='311.8,1170 311.8,1260 233.8,1305 155.9,1260 155.9,1170 233.8,1125'/%3E%3Cpolygon fill='%23526875' stroke='%234d616d' stroke-width='3' points='467.7,1170 467.7,1260 389.7,1305 311.8,1260 311.8,1170 389.7,1125'/%3E%3Cpolygon fill='%23576e7c' stroke='%234e6470' stroke-width='3' points='623.5,1170 623.5,1260 545.6,1305 467.7,1260 467.7,1170 545.6,1125'/%3E%3Cpolygon fill='%23536c7a' stroke='%234f6674' stroke-width='3' points='779.4,1170 779.4,1260 701.5,1305 623.5,1260 623.5,1170 701.5,1125'/%3E%3Cpolygon fill='%23567180' stroke='%234f6876' stroke-width='3' points='935.3,1170 935.3,1260 857.4,1305 779.4,1260 779.4,1170 857.4,1125'/%3E%3Cpolygon fill='%235a7685' stroke='%234e6977' stroke-width='3' points='1091.2,1170 1091.2,1260 1013.2,1305 935.3,1260 935.3,1170 1013.2,1125'/%3E%3Cpolygon fill='%23507080' stroke='%234b6977' stroke-width='3' points='1247.1,1170 1247.1,1260 1169.1,1305 1091.2,1260 1091.2,1170 1169.1,1125'/%3E%3Cpolygon fill='%234e7484' stroke='%23466978' stroke-width='3' points='1403,1170 1403,1260 1325,1305 1247.1,1260 1247.1,1170 1325,1125'/%3E%3Cpolygon fill='%23436f80' stroke='%23406a79' stroke-width='3' points='1558.8,1170 1558.8,1260 1480.9,1305 1403,1260 1403,1170 1480.9,1125'/%3E%3Cpolygon fill='%23407485' stroke='%233b6b7b' stroke-width='3' points='1714.7,1170 1714.7,1260 1636.8,1305 1558.8,1260 1558.8,1170 1636.8,1125'/%3E%3Cpolygon fill='%23417a8b' stroke='%23376c7d' stroke-width='3' points='1870.6,1170 1870.6,1260 1792.7,1305 1714.7,1260 1714.7,1170 1792.7,1125'/%3E%3Cpolygon fill='%23377588' stroke='%23336d7f' stroke-width='3' points='2026.5,1170 2026.5,1260 1948.6,1305 1870.6,1260 1870.6,1170 1948.6,1125'/%3E%3Cpolygon fill='%233a798c' stroke='%23336d7f' stroke-width='3' points='2182.4,1170 2182.4,1260 2104.4,1305 2026.5,1260 2026.5,1170 2104.4,1125'/%3E%3Cg fill-opacity='0.6'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
}
.table-striped tbody tr:nth-of-type(odd) {
   background-color: rgb(241 246 249 / 60%) !important
}
</style>
